module.exports = __webpack_public_path__ + "img/2-first_section.6783400e.png";